import styled from 'styled-components';
import { colors, s32, s4, s8 } from '@ardoq/design-tokens';
import { Icon, IconName } from '@ardoq/icons';
import { isShiftXUrl, urlUtils } from '@ardoq/common-helpers';
import { Link } from '@ardoq/link';
import type { ViewIds } from '@ardoq/api-types';
import { dispatchAction } from '@ardoq/rxbeach';
import type { UrlFieldValue } from './types';
import { urlClicked } from './urlClicked';

// #region styled-components
const UrlFieldValueListElement = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  max-width: 304px;
`;

const UrlFieldValueContainer = styled.li`
  height: ${s32};
  display: flex;
  align-items: center;
  margin: ${s4} 0;
  &:not(:last-child) {
    margin-bottom: ${s8};
  }
`;
const UrlFieldValueTypeIcon = styled(Icon)`
  color: ${colors.grey500};
  margin-right: ${s8};
  vertical-align: middle;
`;
const UrlFieldValueLink = styled(Link).attrs({ typography: 'text2' as const })`
  vertical-align: middle;
  display: flex;
  overflow: hidden;
  > span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;
// #endregion

type UrlFieldValueListProperties = {
  urlFieldValues: UrlFieldValue[];
  viewId: ViewIds | null;
};
const UrlFieldValueList = ({
  urlFieldValues,
  viewId,
}: UrlFieldValueListProperties) => (
  <UrlFieldValueListElement>
    {urlFieldValues.map(({ label, url, isReference }, index) => {
      const href = urlUtils.maybeRelativeUrl(url, isShiftXUrl(url));
      return (
        <UrlFieldValueContainer key={`${label}_${index}`}>
          <UrlFieldValueTypeIcon
            iconName={isReference ? IconName.REFERENCE : IconName.COMPONENT}
          />
          <UrlFieldValueLink
            href={href}
            target="_blank"
            rel="noreferrer"
            onClick={() => dispatchAction(urlClicked({ url, viewId }))}
          >
            {label}
          </UrlFieldValueLink>
        </UrlFieldValueContainer>
      );
    })}
  </UrlFieldValueListElement>
);
export { UrlFieldValueList };
